import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// GlitchTip (Sentry-compatible) browser error tracking. Enabled whenever a DSN
// is configured (dev + prod builds); local runs leave sentryDsn empty and send
// nothing. The environment tag distinguishes dev vs prod issues in GlitchTip.
Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.production ? 'production' : 'development',
  release: environment.appVersion,
  enabled: !!environment.sentryDsn,
});

function showBootstrapError(err: unknown): void {
  console.error(err);
  const detail = environment.production
    ? 'Something went wrong while starting the application. Please try again later.'
    : err instanceof Error ? err.stack ?? err.message : String(err);
  const pre = document.createElement('pre');
  pre.style.padding = '16px';
  pre.style.font = '12px/1.4 monospace';
  pre.style.whiteSpace = 'pre-wrap';
  pre.style.background = '#fff';
  pre.style.color = '#c00';
  pre.style.border = '0';
  pre.style.margin = '0';
  pre.textContent = `Amuvee failed to start.\n\n${detail}`;
  document.body.replaceChildren(pre);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    console.info(
      `Amuvee v${environment.appVersion} [${environment.production ? 'production' : 'development'}]`
    );
  })
  .catch((err) => showBootstrapError(err));
